<template>
    <button class="btn-answer-skip">
        <span class="btn-answer-skip__text">GEÇ</span>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {};
</script>

<style scoped src="@/css/components/btn-answer-skip.css"></style>